import { z } from "zod";
import {
    V2ReviewExpertSchema,
    V2ModerationInfoSchema,
    V2ReviewProjectSchema,
} from "./common";

// Preview rows return id=null and a reduced client shape (no id required).
export const ReviewImportPreviewClientSchema = z.object({
    id: z.number().nullable().optional(),
    name: z.string(),
    email: z.string(),
    company_name: z.string(),
    company_website: z.string().nullable().optional(),
    avatar_url: z.string().nullable().optional(),
    is_repeat_client: z.boolean().optional(),
});

export const ReviewImportPreviewRowSchema = z.object({
    id: z.number().nullable(),
    client: ReviewImportPreviewClientSchema,
    expert: V2ReviewExpertSchema,
    project: V2ReviewProjectSchema.nullable(),
    project_name: z.string().nullable().optional(),
    overall_rating: z.number(),
    quality: z.number().int().min(1).max(5),
    communication: z.number().int().min(1).max(5),
    timelines: z.number().int().min(1).max(5),
    value_for_money: z.number().int().min(1).max(5),
    review_text: z.string(),
    project_value_range: z.string().nullable(),
    is_anonymous: z.boolean(),
    status: z.enum(["draft", "pending", "published", "unpublished"]),
    created_at: z.string(),
    updated_at: z.string(),
    moderation_info: V2ModerationInfoSchema.optional(),
    revision_count: z.number().optional(),
    review_source: z.string(),
    is_hired_on_shopexperts: z.boolean().optional(),
    metadata: z.record(z.string(), z.unknown()).optional(),
});

export const ReviewImportStatusSchema = z.enum(["pending", "published"]);
export type ReviewImportStatus = z.infer<typeof ReviewImportStatusSchema>;

export const ReviewImportSummarySchema = z.object({
    matched_existing_client_count: z.number(),
    shadow_accounts_to_create_count: z.number(),
    ghost_fallback_count: z.number(),
});

export const ReviewImportMetaSchema = z.object({
    mode: z.enum(["preview", "import"]),
    expert_id: z.number(),
    status: ReviewImportStatusSchema,
    row_count: z.number(),
    imported_count: z.number().optional(),
    summary: ReviewImportSummarySchema,
});

export const ReviewImportResponseSchema = z.object({
    success: z.literal(true),
    data: z.array(ReviewImportPreviewRowSchema),
    meta: ReviewImportMetaSchema,
});

export type ReviewImportPreviewRow = z.infer<typeof ReviewImportPreviewRowSchema>;
export type ReviewImportSummary = z.infer<typeof ReviewImportSummarySchema>;
export type ReviewImportMeta = z.infer<typeof ReviewImportMetaSchema>;
export type ReviewImportResponse = z.infer<typeof ReviewImportResponseSchema>;
